import { a as resolveLineColor, d as resolveHandleColor, r as resolveFillColor } from "./styleColors-Cknqcr0q.js";
import { s as styleToDash } from "./styleToDash-DWb71gbd.js";
function buildBaseAttributes({
  SVs,
  layerOffset,
  fixed,
  fixLocation
}) {
  return {
    name: SVs.labelForGraph,
    visible: !SVs.hidden,
    withlabel: SVs.labelForGraph !== "",
    fixed,
    layer: 10 * SVs.layer + layerOffset,
    highlight: !fixLocation
  };
}
function buildLineLikeAttributes({
  SVs,
  layerOffset,
  fixed,
  fixLocation,
  darkMode,
  dashed
}) {
  const lineColor = resolveLineColor(SVs.selectedStyle, darkMode);
  return {
    ...buildBaseAttributes({ SVs, layerOffset, fixed, fixLocation }),
    strokeColor: lineColor,
    strokeOpacity: SVs.selectedStyle.lineOpacity,
    highlightStrokeColor: lineColor,
    highlightStrokeOpacity: SVs.selectedStyle.lineOpacity * 0.5,
    strokeWidth: SVs.selectedStyle.lineWidth,
    highlightStrokeWidth: SVs.selectedStyle.lineWidth,
    dash: styleToDash(SVs.selectedStyle.lineStyle, dashed)
  };
}
function buildFilledShapeAttributes({
  SVs,
  layerOffset,
  fixed,
  fixLocation,
  darkMode,
  dashed
}) {
  const fillColor = resolveFillColor(SVs.selectedStyle, darkMode);
  return {
    ...buildLineLikeAttributes({
      SVs,
      layerOffset,
      fixed,
      fixLocation,
      darkMode,
      dashed
    }),
    fillColor,
    fillOpacity: SVs.selectedStyle.fillOpacity,
    highlightFillColor: fillColor,
    highlightFillOpacity: SVs.selectedStyle.fillOpacity * 0.5
  };
}
function buildDragHandleAttributes({
  elementAttributes,
  layer,
  darkMode,
  showInfoBox
}) {
  return {
    ...elementAttributes,
    withlabel: false,
    fixed: false,
    highlight: true,
    fillColor: "none",
    strokeColor: "none",
    highlightStrokeColor: "none",
    highlightFillColor: resolveHandleColor(darkMode),
    layer,
    showInfoBox
  };
}
export {
  buildLineLikeAttributes as a,
  buildFilledShapeAttributes as b,
  buildDragHandleAttributes as c,
  buildBaseAttributes as d
};
